export const PUBLIC_TRANSPORT_TYPE_NAMES = {
  bus: "Bus",
  subway: "Metro",
  railway: "Ferrocarril",
};
